import {Button} from '@chekinapp/ui';

import {closeSession, hasSession} from 'components/sessions/utils';
import {useTranslation} from 'react-i18next';
import {LogOut} from 'lucide-react';
import {useReservation} from 'context/reservation';

function EndSessionButton() {
  const {t} = useTranslation();
  const {reservationId} = useReservation();

  if (!hasSession(reservationId)) {
    return null;
  }
  return (
    <Button
      onClick={() => closeSession(reservationId)}
      className="end-session-button fixed bottom-[40px] right-4 min-w-[auto] kiosko:hidden"
    >
      <LogOut size={18} />
      {t('exit')}
    </Button>
  );
}

export {EndSessionButton};
